const ACTION = {
    UPDATE_VERIFY_REPAIR_PHONE_TEXT: 'UPDATE_VERIFY_REPAIR_PHONE_TEXT',
}

export default ACTION;